export const EPatientIntakeMethod: {
    STAFF_CREATED: "STAFF_CREATED";
    STAFF_SENT_FORMS: "STAFF_SENT_FORMS";
    STAFF_SCHEDULED_APPOINTMENT: "STAFF_SCHEDULED_APPOINTMENT";
    STAFF_BULK_IMPORT: "STAFF_BULK_IMPORT";
    PATIENT_SIGNUP: "PATIENT_SIGNUP";
    PATIENT_SCHEDULED_APPOINTMENT: "PATIENT_SCHEDULED_APPOINTMENT";
    INTEGRATION: "INTEGRATION";
    FORM_TEMPLATE_GROUP_LINK: "FORM_TEMPLATE_GROUP_LINK";
    UNKNOWN: "UNKNOWN";
    NULL: null;
} = {
    STAFF_CREATED: "STAFF_CREATED",
    STAFF_SENT_FORMS: "STAFF_SENT_FORMS",
    STAFF_SCHEDULED_APPOINTMENT: "STAFF_SCHEDULED_APPOINTMENT",
    STAFF_BULK_IMPORT: "STAFF_BULK_IMPORT",
    PATIENT_SIGNUP: "PATIENT_SIGNUP",
    PATIENT_SCHEDULED_APPOINTMENT: "PATIENT_SCHEDULED_APPOINTMENT",
    INTEGRATION: "INTEGRATION",
    FORM_TEMPLATE_GROUP_LINK: "FORM_TEMPLATE_GROUP_LINK",
    UNKNOWN: "UNKNOWN",
    NULL: null,
};
